import { FETCH_BRAND } from "../actions/brandActions";

const initState = {};

const brandReducer = (state = initState, action) => {
    if (action.type === FETCH_BRAND) {
        return {
            ...state,
            ...action.payload,
        };
    }

    return state;
};

export default brandReducer;
